/** Clés de traduction (fr.json, section auth.errors) pour les erreurs de connexion. */
export type AuthErrorKey = "offline" | "invalidEmail" | "badCode" | "tooMany" | "googleOff" | "unknown";

/** Forme minimale d'une AuthError de Supabase (pas d'import : testable avec node --test). */
export interface AuthErrorLike {
  code?: string;
  status?: number;
  name?: string;
  message?: string;
}

/** Traduit une erreur de Supabase Auth en message simple. Jamais de texte technique à l'écran. */
export function authErrorKey(err: AuthErrorLike, online = true): AuthErrorKey {
  if (!online || err.name === "AuthRetryableFetchError" || err.status === 0) return "offline";
  const code = err.code ?? "";
  const msg = (err.message ?? "").toLowerCase();
  if (code === "otp_expired" || code === "otp_disabled" || msg.includes("token has expired or is invalid"))
    return "badCode";
  if (err.status === 429 || code.startsWith("over_") || msg.includes("rate limit")) return "tooMany";
  if (code === "email_address_invalid" || (code === "validation_failed" && msg.includes("email")))
    return "invalidEmail";
  if (code === "provider_disabled" || msg.includes("provider is not enabled")) return "googleOff";
  return "unknown";
}

/** Un code reçu par e-mail : exactement 6 chiffres (otp_length dans supabase/config.toml). */
export const normalizeCode = (raw: string) => raw.replace(/\D/g, "").slice(0, 6);
